export const questionsDefaultState = {
  conversationClientState: null,
  result: [],
  loading: false
}